<div [class.container]="detailsView">
    <div class="column">
        <div class="row">
            <h3>{{ maintenancePlan?.name }}</h3>
            <div class="button-container" *ngIf="hasNavigation">
                <button class="circular-button" (click)="onNavigate()">
                    <i class="fa fa-share"></i>
                </button>
            </div>
            <app-control-buttons *ngIf="showControls"
                                 class="buttons"
                                 (edit)="onEdit()"
                                 (duplicate)="onDuplicate()"
                                 (delete)="onDelete()">
            </app-control-buttons>
        </div>
        <p *ngIf="showVersion" class="version">
            {{ 'admin.toolMaintenancePlans.plans.version' | translate: {version: maintenancePlan.version} }}
        </p>
        <p class="description">{{ maintenancePlan?.description }}</p>
        <p class="list-label">{{ 'admin.toolMaintenancePlans.plans.modal.appliesTo' | translate }}</p>
        <app-search-bar (search)="onSearch($event)" *ngIf="showControls"></app-search-bar>
        <app-tool-scan-tree *ngIf="!isLoadingTools"
                            class="tools"
                            [loading]="isLoadingTools"
                            [items]="isLoadingTools ? maintenancePlan?.tools : filteredTools">
        </app-tool-scan-tree>
        <div *ngIf="isLoadingTools" class="loading">
            <app-loading-spinner></app-loading-spinner>
        </div>
    </div>
    <div class="column">
        <p class="list-label">{{ 'admin.toolMaintenancePlans.plans.modal.activities' | translate }}</p>
        <app-maintenance-accordion [items]="activities"
                                   [readonly]="true"
                                   (itemClicked)="onTaskClicked($event)">
        </app-maintenance-accordion>
    </div>
</div>
